export const firebaseConfig = {
  apiKey: 'AIzaSyCsyddpkNM61dg1h77BEhgF_c-BrT7CG-k',
  authDomain: 'fitgroupusaapp-prod.firebaseapp.com',
  projectId: 'fitgroupusaapp-prod',
  storageBucket: 'fitgroupusaapp-prod.appspot.com',
  messagingSenderId: '805412740190',
  appId: '1:805412740190:web:c89d4c4d8472a6e71ca8cf',
  measurementId: 'G-38LQV95CM3',
};
